/*
 * Copyright (c) 2025. Orion Analytics. All Rights Reserved
 */

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import oa from '../../img/oa_video.mp4';

export default function VideoModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  const modalRoot = document.getElementById("modal-root");
  if (!modalRoot) return null;

  const backgroundClickCatcher = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "transparent",
    zIndex: 100,
    pointerEvents: "none",	  
  };

  const modalWrapperStyle = {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    width: "400px",
    maxWidth: "90vw",
    zIndex: 102,
    backgroundColor: "#000",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    pointerEvents: "auto",
  };

  const videoStyle = {
    width: "100%",
    height: "auto",
    display: "block",
  };

  const closeButtonStyle = {
    position: "absolute",
    top: "10px",
    right: "10px",
    background: "#fff",
    color: "#f30b0b",
    border: "2px solid #ccc",
    borderRadius: "50%",
    width: "30px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontWeight: "bold",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
    zIndex: 110,
  };

  return ReactDOM.createPortal(
    <>
      <div style={backgroundClickCatcher}/>
      <div style={modalWrapperStyle} onClick={(e) => e.stopPropagation()}>
        <div style={closeButtonStyle} onClick={onClose}>
          ❌
        </div>
        <video style={videoStyle} autoPlay muted controls>
          <source src={oa} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </>,
    modalRoot
  );
}
